{
    "UserRoleLabel": "Ruolo:",
    "RoleCustomLabel": "Personalizzato",
    "RoleRequiresReportingLevel": "Il ruolo degli utenti richiede l'accesso ai rapporti",
    "RoleRequiresNoReportingLevel": "Il ruolo degli utenti non richiede l'accesso ai rapporti",
    "RolePermissionsTooLow": "Non si dispone di autorizzazioni sufficienti per modificare questo utente. Rivolgersi a un amministratore per aumentare i permessi e poter modificare l'utente.",
    "RoleReportingGroup": "RUOLI DI REPORTING",
    "RoleAdminGroup": "RUOLI DI AMMINISTRATORE",
    "NONE": "[None]",
    "REPORTING_USER": "Utente solo per la rendicontazione",
    "ADVANCED_REPORTING_USER": "Utente di reportistica avanzata",
    "END_USER_ADMIN": "Solo per l'utente finale",
    "CUSTOM": "Personalizzato",
    "SUPER_ADMIN": "Amministrazione completa",
    "RESELLER_ADMIN": "Rivenditore",
    "TELEPHONY_SERVER_ADMIN": "Rivenditore - SP",
    "PARTITION_ADMIN": "Rivenditore - Sito",
    "SUPPORT": "Supporto",
    "VIEW": "Amministrazione completa (solo lettura)",
    "BILLING_SUPPORT": "Fatturazione",
    "END_USER_PROVISIONING": "Approvvigionamento",
    "SELF_PROVISIONER": "Provisioning aziendale",
    "Role:NONE": "Non è stato assegnato alcun ruolo, l'utente avrà le autorizzazioni predefinite.",
    "Role:REPORTING_USER": "Un ruolo con un livello di accesso di segnalazione e autorizzazioni predefinite.",
    "Role:ADVANCED_REPORTING_USER": "Supervisore con accesso al reporting e ad alcune azioni avanzate di amministratore",
    "Role:END_USER_ADMIN": "Amministratore con solo azioni avanzate e senza accesso ai rapporti",
    "Role:CUSTOM": "Un ruolo personalizzato con permessi assegnati in base alle necessità",
    "Role:SUPER_ADMIN": "Amministratore con pieni diritti di amministratore (e può avere accesso opzionale ai rapporti)",
    "Role:RESELLER_ADMIN": "Amministratore con tutti i diritti di amministratore, tranne che per la modifica del livello di licenza (e può avere accesso opzionale ai rapporti)",
    "Role:TELEPHONY_SERVER_ADMIN": "Amministratore con pieni diritti di amministratore fino al livello Telefonia (e può avere accesso opzionale ai rapporti)",
    "Role:PARTITION_ADMIN": "Amministratore con pieni diritti di amministratore fino al livello di partizione (e può avere accesso opzionale ai rapporti)",
    "Role:SUPPORT": "Amministratore con diritti di amministratore tecnico e (e può avere accesso opzionale alla reportistica)",
    "Role:VIEW": "Amministratore che può solo visualizzare (e può avere accesso opzionale ai rapporti)",
    "Role:BILLING_SUPPORT": "Amministratore con accesso di sola visualizzazione, ma con la possibilità di scaricare i CDR e vedere i registri di audit (e può avere accesso opzionale alla reportistica)",
    "Role:END_USER_PROVISIONING": "Amministratore con la possibilità di effettuare il provisioning aggiungendo e modificando solo (e può avere accesso opzionale ai report)",
    "Role:SELF_PROVISIONER": "Amministratore in grado di eseguire il provisioning utilizzando la procedura guidata di provisioning (e può avere accesso opzionale alla reportistica)",
    "NAME": "RoleLanguage",
    "UserCustomizedRoles": "MODELLI DI RUOLO PERSONALIZZATI",
    "CreateCustomRole": "Aggiungere un modello di ruolo personalizzato",
    "DeleteCustomRole": "Eliminare il modello di ruolo personalizzato",
    "USER_MANAGER": "Manager dell'utente",
    "Role:USER_MANAGER": "Per gestire gli utenti attraverso il popup Gestione utenti.",
    "Role:TEAMS_PROVISIONING": "Amministratore con capacità di autorizzare e gestire server di telefonia"
}